/* eslint-disable react/jsx-indent-props */
import { makeObservable, observable } from "mobx";
import deviceConfig from "../services/Config";
import ACA from "@adactive/adsum-utils/services/ClientAPI";
import { AdsumLoader, AdsumWebMap } from "@adactive/adsum-web-map";
import React from "react";
import _ from "lodash";

export class GeneralStore {
  loading = true;
  deviceConfig = null;
  entityManager = null;
  activePage = "wayfinder";
  pois = [];
  awm = null;
  aca = null;
  stepLoading = 0;
  searchAction = "";
  from = null;
  historyFrom = [];
  to = null;
  historyTo = [];
  allCategories = [];
  floors = [];
  activeFloor = null;
  tmtType = "";
  isWayfindingRunning = false;
  isFromDirectory = false;
  whatsOns = [];
  tags = [];
  information = [];
  fromSearchAction = false;
  constructor() {
    makeObservable(this, {
      loading: observable,
      activePage: observable,
      pois: observable,
      awm: observable,
      aca: observable,
      stepLoading: observable,
      searchAction: observable,
      from: observable,
      historyFrom: observable,
      to: observable,
      historyTo: observable,
      allCategories: observable,
      floors: observable,
      tmtType: observable,
      activeFloor: observable,
      isFromDirectory: observable,
      whatsOns: observable,
      tags: observable,
      fromSearchAction: observable,
    });
    this.initDevice();
  }

  initDevice = () => {
    // const pattern = /^([A-Za-z "/]{4,})$/;
    // this.stepLoading = this.stepLoading + 1;
    // deviceConfig
    //   .init()
    //   .then(() => ACA.init(deviceConfig.config.api))
    //   .then(() => ACA.load())
    //   .then(() => {
    //     this.stepLoading = this.stepLoading + 1;
    //     this.aca = ACA;
    //     this.deviceConfig = deviceConfig;
    //     var allPOIS = ACA.getAllPois()
    //       .map((poi) => {
    //         const allPlaces = Array.from(poi.places.values).map((place) =>
    //           ACA.getPlace(place.value)
    //         );
    //         const categoryInfo = Array.from(poi.categories.values).map(
    //           (category) => ACA.getCategory(category.value)
    //         );
    //         poi.categories = categoryInfo;
    //         if (categoryInfo.name === "Amenities") {
    //           poi.description = "";
    //         }
    //         const places = _.sortBy(allPlaces, (x) => {
    //           return x.name.split("-")[1];
    //         })
    //           .map((place, index) => {
    //             if (pattern.test(place.name)) {
    //               return place.name;
    //             } else {
    //               if (index === 0) {
    //                 return place.name;
    //               } else {
    //                 const placeNameSplit = place.name.split("-");
    //                 return placeNameSplit[1]
    //                   ? placeNameSplit[1]
    //                   : placeNameSplit[0];
    //               }
    //             }
    //           })
    //           .join("/")
    //           .replace(/_/g, " ");
    //         const floor = allPlaces.length > 0 ? allPlaces[0] : null;
    //         const shape_id =
    //           allPlaces.length > 0 ? allPlaces[0].shape_id : null;
    //         const place_id = allPlaces.length > 0 ? allPlaces[0].id : null;
    //         const tags =
    //           Array.from(poi.tags.values).length > 0
    //             ? ACA.getTagBy({
    //                 id: Array.from(poi.tags.values)[0].value,
    //               })[0].name
    //             : null;
    //         return {
    //           ...poi,
    //           places,
    //           tags,
    //           floor,
    //           shape_id,
    //           place_id,
    //           categoryInfo,
    //         };
    //       })
    //       .filter(
    //         (poi) =>
    //           poi.categoryInfo &&
    //           poi.categoryInfo.length > 0 &&
    //           poi.categoryInfo[0].name !== "Amenities"
    //       );
    //     this.allCategories = ACA.getAllCategories();
    //     this.pois = allPOIS;
    //     this.stepLoading = this.stepLoading + 1;
    //     // _.map(allPOIS, (poi) => {
    //     //   if(poi.floor){
    //     //     if (!this.floors.includes(poi.floor.name)) {
    //     //       this.floors.push(poi.floor.name);
    //     //     }
    //     //   }
    //     // });
    //   })
    //   .then(() => {
    //     setTimeout(() => {
    //       this.stepLoading = this.stepLoading + 1;
    //     }, 1000);
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //   });
  };
}
